<!--
  Copyright (C) 2020 ExploRêve

  This program is free software: you can redistribute it and/or modify
  it under the terms of the GNU Affero General Public License as
  published by the Free Software Foundation, either version 3 of the
  License, or (at your option) any later version.

  This program is distributed in the hope that it will be useful,
  but WITHOUT ANY WARRANTY; without even the implied warranty of
  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
  GNU Affero General Public License for more details.

  You should have received a copy of the GNU Affero General Public License
  along with this program.  If not, see <https://www.gnu.org/licenses/>.

  Full source code is available at <https://gitlab.com/exploreve/frontend>.
-->

<template>
  <b-modal ref="modal" centered size="xl" hide-footer body-bg-variant="primary" header-bg-variant="primary">
    <template v-slot:modal-title> Créer mon ancre </template>
    <div class="row">
      <div class="col-md-8">
        <div>
          <h2>Couleur du fond:</h2>
          <ul class="color-list">
            <li class="color-item" v-for="color in colorsPossible" :key="color">
              <div
                v-if="color != selectedColorFond"
                @click="changeColor(color, 'fond')"
                :style="`background-color: ${color};`"
                class="selectableColor"
              ></div>
              <div v-else :style="`background-color: ${color};`" class="selectedColor"></div>
            </li>
          </ul>
        </div>
        <div>
          <h2>Couleur du liseré:</h2>
          <ul class="color-list">
            <li class="color-item" v-for="color in colorsPossible" :key="color">
              <div
                v-if="color != selectedColorLisere"
                @click="changeColor(color, 'lisere')"
                :style="`background-color: ${color};`"
                class="selectableColor"
              ></div>
              <div v-else :style="`background-color: ${color};`" class="selectedColor"></div>
            </li>
          </ul>
        </div>
        <div>
          <h2>Couleur de la bague:</h2>
          <ul class="color-list">
            <li class="color-item" v-for="color in colorsPossible" :key="color">
              <div
                v-if="color != selectedColorBague"
                @click="changeColor(color, 'bague')"
                :style="`background-color: ${color};`"
                class="selectableColor"
              ></div>
              <div v-else :style="`background-color: ${color};`" class="selectedColor"></div>
            </li>
          </ul>
        </div>

        <div class="w-100" style="text-align: center;"></div>
      </div>
      <div class="col-md-4">
        <div>
          <Foulard class="foulard" />
        </div>
      </div>
    </div>
    <b-button class="mt-3" block @click="send">Créer mon foulard</b-button>
  </b-modal>
</template>
<script>
import Foulard from "@/components/foulard.svg";
import Service from "@/services/memoryMap";

export default {
  name: "scarf-in-modal",
  components: {
    Foulard
  },
  data: function () {
    return {
      selectedColorFond: "#ffffff",
      selectedColorLisere: "#ffffff",
      selectedColorBague: "#ffffff",
      colorsPossible: [
        "#eecea1",
        "#fbdae3",
        "#cd8c31",
        "#5E2A57",
        "#ed4630",
        "#CCCCCC",
        "#4c2b11",
        "#f49c31",
        "#fdf734",
        "#fffab2",
        "#204a1e",
        "#48a37e",
        "#061d72",
        "#224afb",
        "#b2e8fd",
        "#ffffff",
        "#000000",
        "rgba(0,0,0,0)"
      ]
    };
  },
  methods: {
    changeColor: function (color, element) {
      if (element === "fond") {
        let fond = document.getElementById("fond-foulard");
        this.selectedColorFond = color;
        fond.setAttribute("fill", color);
      } else if (element === "lisere") {
        let lisere = document.getElementById("lisere-foulard");
        this.selectedColorLisere = color;
        lisere.setAttribute("fill", color);
      } else if (element === "bague") {
        let bague = document.getElementById("bague-foulard");
        bague.setAttribute("fill", color);
        this.selectedColorBague = color;
      }
    },
    openModal() {
      this.$refs.modal.show();
    },
    send: async function () {
      const colors = {
        border_color: this.selectedColorLisere,
        background_color: this.selectedColorFond,
        knot_color: this.selectedColorBague
      };
      let scarf = await Service.submitScarf(colors);
      this.$refs.modal.hide();
      localStorage.setItem("scarf_id", scarf.id);
      this.$emit("scarf");
    }
  }
};
</script>
<style scss lang="scss">
.foulard {
  height: 50vh;
}
.color-item {
  position: relative;
  width: 24px;
  height: 24px;
  margin: 10px 0 0 10px;
  display: inline-block;
}
.selectableColor {
  width: 100%;
  height: 100%;
}
.selectedColor {
  width: 100%;
  height: 100%;
  border-style: solid;
  border-width: 3px;
}
.send {
  position: absolute;
  width: 400px;
  bottom: 5%;
  left: 30%;
}
</style>
